const moment = require("moment");
import VerbConstants from "motw_core/Constants/VerbConstants";
import { GetEntryPrefix } from "motw_core/Repositories/LogEntryRepository";
import { IDataProvider } from "../Data/IDataProvider";
import { IGoal } from "../Entity/IGoal";
import { IGoalWithDatapoints } from "../Repositories/DatapointRepository";
import { goalsRepository } from "../Repositories/Goals/GoalsRepository_Main";
import { updateGoalsRepository } from "../Repositories/Goals/GoalsRepository_Update";
import { GetTodaysDate } from "./TimeServices";

const GoalsService = () => {
    async function GetMatchingGoalAsync(
        entry: string,
        dataProvider: IDataProvider
    ) {
        return goalsRepository.GetMatchingGoalAsync(entry, dataProvider);
    }

    async function ResetGoalStartDateToToday(
        dataProvider: IDataProvider,
        goal: IGoal
    ) {
        const updatedGoal: IGoalWithDatapoints = {
            ...goal,
            startdate: GetTodaysDate(),
            datapoints: [],
        };

        const preparedGoal = PrepareForDbUpdate(updatedGoal);

        return updateGoalsRepository.UpdateGoalAsync(
            dataProvider,
            preparedGoal,
            false
        );
    }

    async function ChangeGoalDifficulty(
        dataProvider: IDataProvider,
        goal: IGoal,
        newDifficulty: number
    ) {
        const updatedGoal: IGoalWithDatapoints = {
            ...goal,
            difficulty: newDifficulty,
            datapoints: [],
        };

        const preparedGoal = PrepareForDbUpdate(updatedGoal);

        return updateGoalsRepository.UpdateGoalAsync(
            dataProvider,
            preparedGoal,
            false
        );
    }

    async function ToggleGoalIsResonating(
        dataProvider: IDataProvider,
        goal: IGoal
    ) {
        const updatedGoal: IGoalWithDatapoints = {
            ...goal,
            isresonating: !goal.isresonating,
            datapoints: [],
        };

        if (updatedGoal.isresonating) {
            updatedGoal.lastresonance = moment().format();
        }

        const preparedGoal = PrepareForDbUpdate(updatedGoal);

        return updateGoalsRepository.UpdateGoalAsync(
            dataProvider,
            preparedGoal,
            false
        );
    }

    async function UpdateGoalAsync(
        dataProvider: IDataProvider,
        goal: IGoalWithDatapoints,
        shouldAddWeeklyRateChangeDataPoint: boolean
    ) {
        const preparedGoal = PrepareForDbUpdate(goal);

        return updateGoalsRepository.UpdateGoalAsync(
            dataProvider,
            preparedGoal,
            shouldAddWeeklyRateChangeDataPoint
        );
    }

    function PrepareForDbUpdate(goal: IGoalWithDatapoints): Partial<IGoal> {
        const { datapoints, daysleft, ...result } = goal;
        return result;
    }

    function GetNewWeeklyRateChangeDatapoint(
        goal: Partial<IGoal>,
        value: number
    ) {
        return goalsRepository.GetNewWeeklyRateChangeDatapoint(goal, value);
    }

    async function AddWeeklyRateChangeDataPointAsync(
        isRateUnchanged: boolean,
        goal: Partial<IGoal>,
        dataProvider: IDataProvider
    ) {
        return goalsRepository.AddWeeklyRateChangeDataPointAsync(
            isRateUnchanged,
            goal,
            dataProvider
        );
    }

    return {
        GetMatchingGoalAsync,
        ResetGoalStartDateToToday,
        ChangeGoalDifficulty,
        ToggleGoalIsResonating,
        UpdateGoalAsync,
        GetNewWeeklyRateChangeDatapoint,
        AddWeeklyRateChangeDataPointAsync,
    };
};

export const goalsService = GoalsService();
